import { isAlphaNumericKey, isNavigationKey, keyCodes } from '@silevis/reactgrid';
import React from 'react';
import { handleKeyDownDefault } from '../../helpers/global';

class PnLLinkCellTemplate {
  getCompatibleCell(uncertainCell) {
    return {
      ...uncertainCell,
      text: uncertainCell.text || '',
      buyerName: uncertainCell.buyerName || '',
      _id: uncertainCell._id || '',
      newStatus: uncertainCell.newStatus || ''
    };
  }

  handleKeyDown(cell, keyCode, ctrl, shift, alt) {
    return handleKeyDownDefault(cell, keyCode, ctrl, shift, alt);
  }

  update(cell, cellToMerge) {
    return { ...cell, ...cellToMerge };
  }

  render(cell) {
    const url = cell.newStatus === 'Contracted' ? `/contract/${cell._id}` : `/crm/${cell._id}`;

    return (
      <a
        onKeyDown={e => {
          if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
            e.stopPropagation();
          }
        }}
        onPointerDown={e => e.stopPropagation()}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={e => e.stopPropagation()}
        style={{
          color: 'blue',
          textDecoration: 'underline',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {cell.buyerName}
      </a>
    );
  }
}

export const pnlLinkCellTemplate = new PnLLinkCellTemplate();
